import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center p-4 pt-24">
            <div className="border-2 border-terminal-text p-8 rounded-lg max-w-2xl bg-black shadow-[0_0_20px_rgba(0,255,65,0.2)]">
                <h1 className="text-6xl font-bold text-red-500 mb-4 font-mono">FATAL ERROR</h1>
                <p className="text-terminal-text font-mono text-xl mb-8">
                    {">"} KERNEL PANIC: Route not found in current directory.
                </p>
                <div className="text-left bg-terminal-subtle/10 p-4 rounded font-mono text-sm text-terminal-subtle mb-8 overflow-x-auto">
                    <p>*** Stack Trace ***</p>
                    <p>at Request.dispatch (/app/router.js:404:1)</p>
                    <p>at Page.render (/app/core.ts:404:0)</p>
                    <p>at User.navigation (/brain/logic.sh:0:0)</p>
                    <p className="mt-2 text-terminal-text animate-pulse cursor-pointer">_</p>
                </div>
                <Link
                    to="/"
                    className="inline-block bg-terminal-text text-terminal-background px-6 py-2 rounded font-bold font-mono hover:bg-terminal-accent transition-colors"
                >
                    {">"} reboot_system --now
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
